import { config } from '@/lib/env';

// Legacy bop-ui pinned a 4px hazard stripe on every non-production environment so an
// operator can never mistake which environment they are mutating. Preserved deliberately.
export const NonProdBanner = () => {
  if (!config.IS_NON_PROD) return null;

  return (
    <div
      aria-hidden
      className="fixed inset-x-0 top-0 z-50 h-1"
      style={{ background: 'repeating-linear-gradient(45deg, #ffd700, #ffd700 10px, #000 10px, #000 20px)' }}
      title={`Environment: ${config.APP_ENV}`}
    />
  );
};
NonProdBanner.displayName = 'NonProdBanner';
